/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Row, Button, Badge, Spinner } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Check, X, ArrowRight, ChevronLeft } from 'react-feather';
import Breadcrumbs from '../CommonElements/Breadcrumbs';
import { connect } from 'react-redux';
import { updateVerifications as updateVerificationsAction } from '../ReduxToolkit/Reducers/verifications';

function Verification({ updateVerifications }) {
  const location = useLocation();
  const navigate = useNavigate();
  const verification = location.state?.verification;
  const isCompleted = verification?.status === 'completed'

  const [decisions, setDecisions] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!verification) {
      navigate(-1);
    }
  }, [verification]);

  if (!verification) {
    return null;
  }

  const entity = verification.brand || verification.retailer;
  const entityType = verification.brand_id ? 'Brand' : 'Retailer';
  const verificationFields = verification.details || {};

  const handleDecision = (fieldName, decision) => {
    setDecisions(prev => ({
      ...prev,
      [fieldName]: decision
    }));
  };

  const handleSubmit = async () => {
    // Check if all fields have decisions
    const allFieldsDecided = Object.keys(verificationFields).every(field =>
      decisions[field] === 'approved' || decisions[field] === 'disapproved'
    );

    if (!allFieldsDecided) {
      alert('Please approve or disapprove all fields before submitting.');
      return;
    }

    setIsSubmitting(true);

    try {
      // Build the payload with the required structure
      const details = {};

      Object.keys(verificationFields).forEach(fieldName => {
        const fieldData = verificationFields[fieldName];
        const decision = decisions[fieldName];

        details[fieldName] = {
          ...fieldData,
          status: decision === 'approved' ? 'completed' : 'rejected'
        };
      });

      const payload = {
        id: verification.id,
        details
      };

      console.log('Submitting payload:', payload);

      // Call the API
      await updateVerifications(payload);

      // Navigate back to verifications list
      navigate(-1);
    } catch (error) {
      console.error('Error submitting decisions:', error);
      alert('Failed to submit decisions. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatFieldName = (fieldName) => {
    return fieldName
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  const allDecisionsMade = Object.keys(verificationFields).length === Object.keys(decisions).length &&
    Object.keys(verificationFields).every(field => decisions[field]);

  return (
    <div className='page-body'>
      <Breadcrumbs pageTitle='Verification' parent='Verifications' title='Review Update Request' />
      <Container fluid>
        <Row>
          <Col xs={12}>
            <Button
              color="link"
              className="ps-0 mb-3 d-flex align-items-center"
              onClick={() => navigate(-1)}
            >
              <ChevronLeft size={18} />
              <span className="ms-1">Back to table</span>
            </Button>
          </Col>
        </Row>

        {/* Entity Header Card */}
        <Row>
          <Col xs={12}>
            <Card className="mb-4">
              <CardBody>
                <Row className="align-items-center">
                  <Col xs="auto">
                    {entity?.logo && (
                      <img
                        src={entity.logo}
                        alt={entity.name}
                        style={{
                          width: '80px',
                          height: '80px',
                          objectFit: 'contain',
                          borderRadius: '8px',
                          border: '1px solid #e0e0e0'
                        }}
                      />
                    )}
                  </Col>
                  <Col>
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <h4 className="mb-0">{entity?.name}</h4>
                      <Badge color="info">{entityType}</Badge>
                      <Badge
                        color={verification.status === 'processing' ? 'warning' :
                          verification.status === 'approved' ? 'success' : 'danger'}
                      >
                        {verification.status}
                      </Badge>
                    </div>
                    <p className="text-muted mb-0">
                      Submitted on {formatDate(verification.created_at)}
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Verification Fields */}
        <Row>
          <Col xs={12}>
            <h5 className="mb-3">Updates Requiring Verification</h5>
          </Col>
        </Row>

        <Row>
          {Object.entries(verificationFields).map(([fieldName, fieldData]) => {
            const decision = decisions[fieldName];
            console.log(fieldData)
            return (
              <Col xs={12} key={fieldName} className="mb-4">
                <Card
                  className={`border ${decision === 'approved' ? 'border-success' :
                    decision === 'disapproved' ? 'border-danger' : ''
                    }`}
                  style={{ borderWidth: decision ? '2px' : '1px' }}
                >
                  <CardBody>
                    <Row className="align-items-center">
                      <Col md={4}>
                        <div className="mb-3 mb-md-0">
                          <h6 className="text-muted mb-2 text-uppercase" style={{ fontSize: '0.75rem' }}>
                            Field
                          </h6>
                          <h5 className="mb-0">{formatFieldName(fieldName)}</h5>
                          {fieldData.link && fieldData.link !== 'test' && (
                            <Button
                              color="primary"
                              size="sm"
                              className="mt-2"
                              onClick={() => window.open(fieldData.link, '_blank', 'noopener,noreferrer')}
                            >
                              View Source
                            </Button>
                          )}
                        </div>
                      </Col>

                      <Col md={3}>
                        <div className="mb-3 mb-md-0">
                          <h6 className="text-muted mb-2 text-uppercase" style={{ fontSize: '0.75rem' }}>
                            Current Value
                          </h6>
                          <div className="p-2 bg-light rounded">
                            <strong className="text-primary">{typeof fieldData?.oldValue === 'string' ? fieldData?.oldValue : fieldData.oldValue?.join(', ') || '--'}</strong>
                          </div>
                        </div>
                      </Col>

                      <Col md={1} className="text-center d-none d-md-block">
                        <ArrowRight size={24} className="text-muted" />
                      </Col>

                      <Col md={3}>
                        <div className="mb-3 mb-md-0">
                          <h6 className="text-muted mb-2 text-uppercase" style={{ fontSize: '0.75rem' }}>
                            Proposed Value
                          </h6>
                          <div className="p-2 bg-light rounded border border-primary">
                            <strong className="text-primary">{typeof fieldData?.value === 'string' ? fieldData?.value : fieldData.value?.join(', ') || '--'}</strong>
                          </div>
                        </div>
                      </Col>

                      <Col md={1} className="d-none d-md-block" />
                    </Row>

                    {!isCompleted && (
                      <Row className="mt-3">
                        <Col xs={12}>
                          <div className="d-flex gap-2 justify-content-end">
                            <Button
                              color={decision === 'approved' ? 'success' : 'outline-success'}
                              onClick={() => handleDecision(fieldName, 'approved')}
                              className="d-flex align-items-center gap-2"
                              disabled={isSubmitting}
                            >
                              <Check size={18} />
                              {decision === 'approved' ? 'Approved' : 'Approve'}
                            </Button>
                            <Button
                              color={decision === 'disapproved' ? 'danger' : 'outline-danger'}
                              onClick={() => handleDecision(fieldName, 'disapproved')}
                              className="d-flex align-items-center gap-2"
                              disabled={isSubmitting}
                            >
                              <X size={18} />
                              {decision === 'disapproved' ? 'Disapproved' : 'Disapprove'}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    )}

                    {decision && (
                      <Row className="mt-3">
                        <Col xs={12}>
                          <div
                            className={`p-2 rounded ${decision === 'approved' ? 'bg-success-subtle text-success' :
                              'bg-danger-subtle text-danger'
                              }`}
                            style={{
                              backgroundColor: decision === 'approved' ? '#d1f4e0' : '#fdd',
                              fontSize: '0.9rem'
                            }}
                          >
                            <strong>
                              {decision === 'approved'
                                ? ` This change will be approved and "${fieldData.value}" will replace "${fieldData.oldValue}"`
                                : ` This change will be rejected and "${fieldData.oldValue}" will remain unchanged`
                              }
                            </strong>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>

        {/* Submit Section */}
        {!isCompleted && (
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <Row className="align-items-center">
                    <Col>
                      <h6 className="mb-0">
                        {allDecisionsMade
                          ? 'All fields reviewed. Ready to submit.'
                          : `${Object.keys(decisions).length} of ${Object.keys(verificationFields).length} fields reviewed`
                        }
                      </h6>
                    </Col>
                    <Col xs="auto">
                      <Button
                        color="primary"
                        size="lg"
                        onClick={handleSubmit}
                        disabled={!allDecisionsMade || isSubmitting}
                        className="d-flex align-items-center gap-2"
                      >
                        {isSubmitting && <Spinner size="sm" />}
                        {isSubmitting ? 'Submitting...' : 'Submit Decisions'}
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

const mapDispatchToProps = {
  updateVerifications: updateVerificationsAction,
}
export default connect(null, mapDispatchToProps)(Verification);
